import { PasswordRecoverySchema, PasswordRecoverySentSchema } from '@/lib/schemas/guestAuth'
import { getRequest, postRequest, putRequest } from '@/lib/request'

export const sendRecoveryLink = (params: PasswordRecoverySentSchema) => {
  return postRequest('/admin/account/reset-password', params, {
    showToast: true,
    pendingMessage: `Sending password reset link to ${params.email}...`,
    successMessage: `Password reset link has been sent to ${params.email}.`,
    errorMessage: `Failed to send reset link to ${params.email}. Please try again.`,
  })
}

export const recoveryPassword = (
  params: PasswordRecoverySchema & { token: string }
): Promise<boolean> => {
  return putRequest('/admin/account/reset-password/confirm', params, {
    showToast: true,
    pendingMessage: 'Setting your new password...',
    successMessage: 'Your password has been successfully reset!',
    errorMessage: 'Failed to reset password. Please try again.',
    headers: { Authorization: `Bearer ${params.token}` },
  })
}

export const getRecoveryTokenStatus = (token: string): Promise<boolean> => {
  return getRequest('/admin/account/reset-password/status', null, {
    headers: { Authorization: `Bearer ${token}` },
  })
}
